import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.match.js";
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
var PROFILE_PATHS = {
  company: '/grupos/',
  bank: '/bancos/',
  user: '/usuario/'
};
export var ARTICLES_WITH_NEW_URL = ['mejores-hipotecas', 'las-mejores-hipotecas-fijas-del-mercado-compara-y-descubre-la-que-mejor-se-adapta-a-ti', 'las-mejores-hipotecas-variables-elige-la-que-mas-te-conviene', 'las-mejores-hipotecas-mixtas-del-mercado-descubre-cual-es-la-tuya-mayo-2024', 'como-calcular-una-hipoteca-en-espana', 'como-reclamar-los-gastos-de-la-hipoteca-guia-completa'];
var GROUPS_WITH_COVER = ['bbva', 'caixabank', 'finizens', 'raisin', 'santander'];
export var IMAGES_PATH = '/v4/resources/media/images/';
export var IMAGES_DEFAULT_FORMAT = 'webp';
export var getAuthorPath = function getAuthorPath(author) {
  if (author.isBank) {
    return "".concat(PROFILE_PATHS.bank).concat(author.alias);
  }
  return PROFILE_PATHS[author.subtype] ? PROFILE_PATHS[author.subtype] + author.alias : '#';
};
export var getArticlePath = function getArticlePath(article) {
  if (article.alias && ARTICLES_WITH_NEW_URL.includes(article.alias)) {
    return "/articulos/".concat(article.alias);
  }
  if (article.body && article.body.url && article.body.url.startsWith('/bancos')) {
    return article.body.url;
  }
  if (['external-link'].includes(article.type) && article.body && article.body.url) {
    return article.body.url;
  }
  if (['external-link'].includes(article.type) && article.url) {
    return article.url;
  }
  if (article.author) {
    var authorPath = getAuthorPath(article.author);
    return article.alias ? "".concat(authorPath, "/articulos/").concat(article.alias) : '#';
  }
  return '#';
};
export var getArticleURL = function getArticleURL(article) {
  var isClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var path = getArticlePath(article);
  return path.startsWith('/') ? !isClient ? getSuperPartnerBaseURL() + path : path : path;
};
export var getArticleImageUrl = function getArticleImageUrl(article) {
  var withAuthorImage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var imageWidth = arguments.length > 2 ? arguments[2] : undefined;
  if (withAuthorImage) {
    var _ref = article.author || {},
      authorIcon = _ref.icon;
    if (authorIcon) return "".concat(getSuperPartnerBaseURL()).concat(IMAGES_PATH).concat(authorIcon);
  }
  if (article.image) {
    var image = article.image.trim();
    if (!image.includes('finect.com')) return image;
    if (image.startsWith('http')) image = image.replace('http://', 'https://');
    if (image.includes(' ')) image = image.replace(' ', '%20');
    if (image.includes('.com/image/')) image = image.replace('/image/', IMAGES_PATH);
    var split = image.split('-');
    var sizeParam = split.find(function (s) {
      return s.match(/^[wh]\d+/);
    });
    var formatParam = split.find(function (s) {
      return s.match(/^[a-z]{3,4}$/);
    });
    if (imageWidth) {
      if (!image.includes('-')) image = "".concat(image, "-w").concat(imageWidth);
      if (sizeParam && sizeParam !== "w".concat(imageWidth)) image = image.replace(sizeParam, "w".concat(imageWidth));
    }
    if (!formatParam) image = "".concat(image, "-").concat(IMAGES_DEFAULT_FORMAT);
    return image;
  }
  if (article.author && GROUPS_WITH_COVER.includes(article.author.alias)) {
    return "https://static.finect.com/img/articles/organization-covers/".concat(article.author.alias, ".jpg");
  }
  return null;
};
export var getArticleRel = function getArticleRel(article) {
  if (article.body.metadata) {
    if (article.type === 'external-link' || article.body.metadata.index === 'noindex') return 'nofollow';
  }
  var _ref2 = article.author || {
      features: []
    },
    _ref2$features = _ref2.features,
    features = _ref2$features === void 0 ? [] : _ref2$features,
    subtype = _ref2.subtype;
  if (subtype === 'user' && features.includes('noindex')) {
    return 'nofollow';
  }
  return '';
};